import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = createClient({
  projectId: '8tosaj0i',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2024-01-31',
})

const builder = imageUrlBuilder(client)

export function urlFor(source) {
  return builder.image(source)
}
